export type Theme = "light" | "dark" | "beige";

export const THEMES: Theme[] = ["light", "dark", "beige"];

export const STORAGE_KEY = "paperclip-theme";

export const isTheme = (v: unknown): v is Theme =>
  v === "light" || v === "dark" || v === "beige";

const prefersDark = (): boolean => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return false;
  }
};

/** Stored choice, or the OS scheme when nothing has been saved yet. */
export const resolveTheme = (): Theme => {
  if (typeof localStorage !== "undefined") {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (isTheme(stored)) return stored;
    } catch {
      /* private mode, etc. */
    }
  }
  return prefersDark() ? "dark" : "light";
};

/** Reflect the theme onto <html> so CSS tokens and native widgets match. */
export const applyTheme = (theme: Theme) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (theme === "light") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
  // Native widgets (scrollbars, form controls) follow color-scheme; beige is a
  // light theme.
  root.style.colorScheme = theme === "dark" ? "dark" : "light";
};

export const persistTheme = (theme: Theme) => {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* ignore storage failures (private mode, etc.) */
  }
};

export const bootTheme = () => {
  applyTheme(resolveTheme());
};
